import AIDashboardGenerator from './ai-dashboard-generator';

function App() {
  return <AIDashboardGenerator />;
}

export default App;
